import { ThreadWithMetadata } from 'ClientPortal/src/api/Queries/threads'
import { useFormQueryParams } from 'ClientPortal/src/router/useFormQueryParams'

type UseThreadSelectionProps = {
    threads: ThreadWithMetadata[]
}

export function useThreadSelection({ threads }: UseThreadSelectionProps) {
    const { activeThreadId, setActiveThreadId } = useFormQueryParams()

    return {
        onClickThread: setActiveThreadId,
        selectedThread: threads.find((thread) => thread.uuid === activeThreadId) || threads.at(0),
    }
}
